import Vue from 'vue'
import Router from 'vue-router'

import BookShelfSubscribe from '@/views/BookShelfSubscribe'
import BookShelfGift from '@/views/BookShelfGift'
import BookShelfSummary from '@/views/BookShelfSummary'

import PaymentStatus from '@/views/PaymentStatus'

import Register from '@/views/Register'
import Login from '@/views/Login'
import PasswordReset from '@/views/PasswordReset'

import BookShelfDetails from '@/views/BookShelfDetails'

import Subscription from '@/views/Subscription'
import Shipment from '@/views/Shipment'

import UserManage from '@/views/UserManage'
import UserAddressList from '@/views/UserAddressList'

import store from '@/store/store'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/subscription')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // Bookshelf subscription selection page
    {
      path: '/subscribe',
      name: 'Subscribe',
      component: BookShelfSubscribe
    },

    // Gifting landing page
    {
      path: '/gift',
      name: 'Gift',
      component: BookShelfGift
    },

    // Booking summary (before payment) page
    {
      path: '/summary',
      name: 'Summary',
      component: BookShelfSummary
    },

    // Booking payment status page
    {
      path: '/payment-status/:requestID',
      name: 'PaymentStatus',
      props: true,
      component: PaymentStatus
    },

    // Register
    {
      path: '/register/:k',
      name: 'Register',
      props: true,
      component: Register,
      beforeEnter: (to, from, next) => {
        if (!store.getters.isAuthenticated) {
          next()
          return
        }
        // If logged in, go directly to confirm delivery details page
        next({ path: '/confirm-details/' + to.params.k })
      }
    },

    // Password Reset
    {
      path: '/reset-password/:k?',
      name: 'PasswordReset',
      component: PasswordReset,
      props: true,
      beforeEnter: ifNotAuthenticated
    },

    // Confirm details
    {
      path: '/confirm-details/:k',
      name: 'ConfirmDetails',
      props: true,
      component: BookShelfDetails
    },

    // Subscription list
    {
      path: '/subscription',
      name: 'Subscription',
      component: Subscription,
      beforeEnter: ifAuthenticated
    },

    // Shipment list
    {
      path: '/shipment',
      name: 'Shipment',
      component: Shipment,
      beforeEnter: ifAuthenticated
    },

    // User Management
    {
      path: '/profile',
      name: 'User',
      component: UserManage,
      beforeEnter: ifAuthenticated
    },

    // User Address List
    {
      path: '/address',
      name: 'UserAddressList',
      component: UserAddressList,
      beforeEnter: ifAuthenticated
    },

    // Login
    {
      path: '/:k?',
      name: 'Login',
      props: true,
      component: Login,
      beforeEnter: ifNotAuthenticated
    }
  ]
})
